export default __webpack_public_path__ + "static/media/Termo de Cessão de Diárias - 15032022.be43d3a6.pdf";